import NumberSquare from "./NumberSquares";

export default NumberSquare;
